import { tgxApi } from "../../app/tgxApi";
import {
    getAuthorizationHeader,
    getFileDownloadHeaders,
    handleQueryError,
    handleQueryErrorAndSuccess
} from "../../helpers/utils/RtkQueryUtils";
import { serialize } from "../../helpers/utils/Utils";

export const ordersApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({
        searchOrders: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/ajax/orders?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
            providesTags: ["orders"]
        }),
        searchAllFileDataNew: build.query({
            query: (data) => {
                return {
                    url: `/ajax/get-document-for-delivery`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: data
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
            providesTags: ["getAllFileDataNew"]
        }),
        searchAllFileDataOld: build.query({
            query: (data) => {
                return {
                    url: `/ajax/get-document-for-delivery`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: data
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
            providesTags: ["getAllFileDataOld"]
        }),
        // Define the endpoint for searching orders
        getOrderById: build.query({
            query: (orderId) => {
                return {
                    url: `/orders/${orderId}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ["orderById"],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        checkPrimaryCollectorExistAction: build.query({
            query: ({ county, stateAbbreviation }) => {
                let params = serialize({ county: county, stateAbbreviation: stateAbbreviation })
                return {
                    url: `/editor/primaryCollector?${params}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['checkPrimaryCollectorExist'],
            async onQueryStarted(_, { queryFulfilled }) {
            },
        }),

        getOrderByOrderIdAndType: build.query({
            query: ({ orderId, orderType }) => {
                return {
                    url: `/ajax/get-order-by-id/${orderId}/${orderType}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['getOrderByOrderIdAndType'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        getOrderResultByOrderId: build.query({
            query: (orderId) => {
                return {
                    url: `/editor/get-order-result-by-order-id/${orderId}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ["getOrderResultByOrderId"],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        getHoaOrderResultByOrderId: build.query({
            query: (orderId) => {
                return {
                    url: `/editor/get-order-hoa-result-by-order-id/${orderId}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ["getHoaOrderResultByOrderId"],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        getCadInformation: build.query({
            query: ({ list, countyId }) => {
                return {
                    url: `/editor/populateCadInfo?countyId=${countyId}`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: list
                };
            },
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        createOrder: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/ajax/submit/order`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['orders'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Created", "Order")
            },
        }),

        saveOrderResultService: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/editor/save-order-result`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['getOrderResultByOrderId', 'getHoaOrderResultByOrderId', 'qcLogicResultList', 'getOrderByOrderIdAndType'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "order")
            },
        }),

        deliverPdf: build.mutation({
            query: ({ docList, orderId, deliveryEmail, productId }) => {
                let paramData = serialize({
                    orderId: orderId, deliveryEmail: deliveryEmail, productId: productId,
                });
                return {
                    url: `/ajax/pdf-delivered?${paramData}`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: docList
                };
            },
            invalidatesTags: ['getOrderByOrderIdAndType','getOrderResultByOrderId', 'getHoaOrderResultByOrderId', 'orderDocumentList', 'orderLogs'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Delivered", "Pdf")
            },
        }),

        checkTaxOrderResultValid: build.query({
            query: (requestBody) => {
                return {
                    url: `/editor/default/validateTaxGeneratePdf`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            providesTags: ['validateTaxGeneratePdf'],

        }),

        getContactEmailByOrderId: build.query({
            query: (orderId) => {
                return {
                    url: `/orders/contact-emails/${orderId}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['getContactEmailByOrderId'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        getContactEmail: build.query({
            query: (orderDto) => {
                return {
                    url: `/ajax/get-contact-email`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: orderDto
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        checkUserIsManager: build.query({
            query: (orderId) => {
                return {
                    url: `/ajax/check-is-user-manager/${orderId}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled);
            },
        }),

        refreshRoll: build.mutation({
            query: (orderId) => {
                return {
                    url: `/ajax/refresh-roll/${orderId}`,
                    method: 'POST',
                    headers: getAuthorizationHeader()
                };
            },
            invalidatesTags:['getOrderByOrderIdAndType','getOrderResultByOrderId'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Order  successfully")
            },
        }),

        getCertificateOptionsByOrderId: build.query({
            query: (orderId) => {
                return {
                    url: `/editor/order-results/options/${orderId}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ["certificateOptionsByOrderId"],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        checkIsPdfExist: build.query({
            query: (query) => {
                return {
                    url: `/ajax/isPdfExist`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: query
                };
            },
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),

        generateSOAPdfService: build.mutation({
            query: ({ orderId, customerId, tenant, tgxId, productId, obj }) => {
                let typesList = { customerId: customerId, tenant: tenant, tgxId: tgxId, productId:productId };
                let param = serialize(typesList);
                return {
                    url: `/editor/generate-statement-of-account-pdf/${orderId}?${param}`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: obj
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Generated", "Statement of Account request")
            },
        }),
        generateTgxPdfService: build.mutation({
            query: ({ orderId, customerId, tenant, checkValidation, cancelExistingTask }) => {

                return {
                    url: `/editor/generate-tgx-pdf/${orderId}/${customerId}/${tenant}/${checkValidation}/${cancelExistingTask}`,
                    method: 'POST',
                    headers: getFileDownloadHeaders(),
                };
            },
            invalidatesTags: ['productTaskList', 'getOrderResultByOrderId', 'getOrderByOrderIdAndType']
        }),

        generateCadPrintoutPdfService: build.mutation({
            query: ({ orderId, certificateAccountDefaultDTOS }) => {
                return {
                    url: `/files/generate-cad-printout-pdf?orderId=${orderId}`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                };
            },
        }),
        generateHoaPdfService: build.mutation({
            query: ({ orderId, customerId, tenant, checkValidation, cancelExistingTask }) => {

                return {
                    url: `/editor/generate-hoa-pdf/${orderId}/${customerId}/${tenant}/${checkValidation}/${cancelExistingTask}`,
                    method: 'POST',
                    headers: getFileDownloadHeaders(),
                };
            },
            invalidatesTags: ['productTaskList', 'getHoaOrderResultByOrderId', 'getOrderByOrderIdAndType']
        }),

        updateProductStatus: build.mutation({
            query: ({ productId, productStatus }) => {
                return {
                    url: `/ajax/update-product-status/${productId}/${productStatus}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                };
            },
            invalidatesTags: ['getOrderResultByOrderId', 'getHoaOrderResultByOrderId', 'getOrderByOrderIdAndType'],
        }),

        sendSOAPdfByEmailService: build.mutation({
            query: ({ orderId, toAddress, ccAddress, mailSubject, filename }) => {
                let paramData = serialize({
                    orderId: orderId,
                    toAddress: toAddress,
                    ccAddress: ccAddress,
                    mailSubject: mailSubject,
                    filename: filename
                });
                return {
                    url: `/editor/send-soa-attachment?${paramData}`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: paramData
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Sent", "SOA Request email")
            },
        }),

        isPdfExist: build.mutation({
            query: (query) => ({
                url: '/ajax/isPdfExist',
                method: 'POST',
                headers: getAuthorizationHeader(),
                body: query,
            }),
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),
        checkHoaOrderResultValid: build.mutation({
            query: ({ orderId, obj }) => ({
                url: `/editor/validateHoaGeneratePdf/${orderId}`,
                method: 'POST',
                headers: getAuthorizationHeader(),
                body: obj,
            }),

            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),
        getSimilarHoaAccountInfo: build.query({
            query: ({ orderId, propertyIds }) => {
                const param = serialize({
                    orderId,
                    propertyIds
                });
                return {
                    url: `/editor/get-similar-hoa-account-info?${param}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(), // Assuming you use it like in other services
                };
            },
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),
        getOrderSelectedFiles: build.query({
            query: ({ orderId, formType }) => {
                const param = serialize({ orderId, formType });
                return {
                    url: `/ajax/selected-documents?${param}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(), // use if your project uses auth headers
                };
            },

            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),


        saveHoaOrderResult: build.mutation({
            query: ({ obj, orderId }) => ({

                url: `/editor/save-hoa-order-result/${orderId}`,
                method: 'POST',
                body: obj,
                headers: getAuthorizationHeader(), // Assuming you want to send authorization headers
            }),
            invalidatesTags: ['getHoaOrderResultByOrderId', 'getOrderByOrderIdAndType', "getOrderByOrderIdAndType"],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Saved", "order results");
            },
        }),

        unMarkedProductFiles: build.mutation({
            query: (productId) => ({
                url: `/ajax/unmarked-product-all-files/${productId}`,
                method: 'PUT',
                headers: getAuthorizationHeader(), // if required
            }),
            invalidatesTags: ['getOrderResultByOrderId', 'getHoaOrderResultByOrderId', 'getOrderByOrderIdAndType'],
            async onQueryStarted(queryFulfilled) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Unmarked", "Document Successfully");
            },
        }),
        markedProductFiles: build.mutation({
            query: ({ productId, files }) => ({
                url: `/ajax/marked-product-files/${productId}`,
                method: 'PUT',
                body: files,
                headers: getAuthorizationHeader(), // if needed
            }),
            invalidatesTags: ['getOrderResultByOrderId', 'getHoaOrderResultByOrderId', 'getOrderByOrderIdAndType'],
            async onQueryStarted(queryFulfilled) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Marked documents for delivery", "");

            },
        }),
        getProductQcLogicResultList: build.query({
            query: (productId) => ({
                url: `/editor/getProductQcLogicResultList/${productId}`,
                method: 'GET',
                headers: getAuthorizationHeader(),
            }),
            providesTags: ['ProductQcLogicResult']
        }),
        acknowledgeQcLogic: build.mutation({
            query: (qcId) => ({
                url: `/editor/acknowledgeQcLogic/${qcId}`,
                method: 'PUT',
                headers: getAuthorizationHeader(),
            }),
            invalidatesTags: ['getOrderResultByOrderId', 'qcLogicResultList'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled); // optional, if you're using centralized error handling
            },
        }),

        computeOrderStatus: build.mutation({
            query: (products) => ({
                url: `/ajax/orders/computeOrderStatus`,
                method: 'PUT',
                body: products,
                headers: getAuthorizationHeader(), // if required
            }),

        }),

        updateProductsStatus: build.mutation({
            query: ({ products, shouldFlushResults }) => ({
                url: `/ajax/products/updateStatuses?shouldFlushResults=${shouldFlushResults}`,
                method: 'PUT',
                body: products,
                headers: getAuthorizationHeader(), // if required
            }),
            invalidatesTags: ["getOrderByOrderIdAndType"],
            async onQueryStarted(queryFulfilled) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Order Status");
            },
        }),

        updatePropertyResults: build.mutation({
            query: ({ orderId, propertyId, propertyResult }) => ({
                url: `/ajax/orders/property/${orderId}/${propertyId}`,
                method: 'PUT',
                body: propertyResult,
                headers: getAuthorizationHeader(), 
            }),
            invalidatesTags: ["getOrderByOrderIdAndType"],
            async onQueryStarted(queryFulfilled) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Property Result");
            },
        }),
        updateTaxAccounts: build.mutation({
            query: ({ accounts, orderId, productId, taxYear }) => ({
                url: `/editor/submit-tax-update/${orderId}/${productId}?taxYear=${taxYear}`,
                method: 'POST',
                body: accounts,
                headers: getAuthorizationHeader(), // Assuming you want to send authorization headers
            }),
            invalidatesTags: ['productTaskList'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Started Tax Update", "Task");
            },
        }),

        getSimilarTaxAccountList: build.query({
            query: ({ orderId, propertyIds }) => {
                let obj = {
                    "orderId": orderId, "propertyIds": propertyIds
                }
                let param = serialize(obj);
                return {
                    url: `/editor/default/get-similar-tax-account-info?${param}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['orderLogs'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        addParentAccountsForSubdivision: build.mutation({
            query: ({ subdivisionId, orderResults }) => ({
                url: `/editor/add-parent-account/${subdivisionId}`,
                method: 'PUT',
                body: orderResults,
                headers: getAuthorizationHeader(), // if required
            }),
            invalidatesTags: ["getOrderResultByOrderId"],
        }),

        sendToVendor: build.mutation({
            query: ({ propertyIdList, productId }) => ({
                url: `/ajax/send-to-vendor/${productId}`,
                method: 'POST',
                body: propertyIdList,
                headers: getAuthorizationHeader(), // if required
            }),
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Send", "Send To Vendor")
            },
        }),

        parseImportedData: build.mutation({
            query: (importData) => ({
                url: `/ajax/parse-imported-data-from-email?${importData}`,
                method: 'POST',
                headers: getAuthorizationHeader(), // if required
            }),
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Imported", "Order Data")
            },
        }),
        cancelOrderOnLocate: build.mutation({
            query: ({ orderId, productId }) => ({
                url: `/ajax/cancelOrderOnLocate/${orderId}/${productId}`,
                method: 'PUT',
                headers: getAuthorizationHeader(), // if required
            }),
            invalidatesTags: ["getOrderResultByOrderId"],
        }),

        searchTaxSuitCollector: build.query({
            query: (data) => {
                // Serialize the data to query parameters
                let paramData = serialize(data);
                return {
                    url: `/ajax/tax-suit-collectors?${paramData}`,
                    method: 'POST',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['taxSuitsCollector'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getOrdersInSubdivisionList: build.query({
            query: ({ subdivisionId, productStatuses }) => {
                const obj = {
                    subdivisionId,
                    ...(productStatuses != null ? { productStatuses } : {})
                };
                let param = serialize(obj);
                return {
                    url: `/editor/subdivision-orders-lookup?${param}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
    }),
});

export const {
    useParseImportedDataMutation,
    useLazyGetSimilarTaxAccountListQuery,
    useSearchOrdersQuery,
    useSearchTaxSuitCollectorQuery,
    useLazySearchOrdersQuery,
    useCreateOrderMutation,
    useGetContactEmailByOrderIdQuery,
    useGetOrderByOrderIdAndTypeQuery,
    useLazyGetOrderByOrderIdAndTypeQuery,
    useLazyCheckPrimaryCollectorExistActionQuery,
    useGetOrderResultByOrderIdQuery,
    useLazyGetCadInformationQuery,
    useGetHoaOrderResultByOrderIdQuery,
    useCheckUserIsManagerQuery,
    useGenerateSOAPdfServiceMutation,
    useSendSOAPdfByEmailServiceMutation,
    useIsPdfExistMutation,
    useCheckHoaOrderResultValidMutation,
    useLazyGetSimilarHoaAccountInfoQuery,
    useSaveHoaOrderResultMutation,
    useSaveOrderResultServiceMutation,
    useGenerateTgxPdfServiceMutation,
    useGenerateHoaPdfServiceMutation,
    useLazyCheckTaxOrderResultValidQuery,
    useCheckTaxOrderResultValidQuery,
    useRefreshRollMutation,
    useGetCertificateOptionsByOrderIdQuery,
    useLazyGetContactEmailQuery,
    useUpdateProductStatusMutation,
    useSearchAllFileDataNewQuery,
    useSearchAllFileDataOldQuery,
    useDeliverPdfMutation,
    useGetOrderSelectedFilesQuery,
    useUnMarkedProductFilesMutation,
    useMarkedProductFilesMutation,
    useAcknowledgeQcLogicMutation,
    useComputeOrderStatusMutation,
    useUpdateProductsStatusMutation,
    useUpdatePropertyResultsMutation,
    useUpdateTaxAccountsMutation,
    useAddParentAccountsForSubdivisionMutation,
    useSendToVendorMutation,
    useCancelOrderOnLocateMutation,
    useCheckIsPdfExistQuery,
    useGenerateCadPrintoutPdfServiceMutation,
    useLazyGetOrdersInSubdivisionListQuery
} = ordersApi;